// extracted by mini-css-extract-plugin
module.exports = {"root":"CommTypeTabs_root__1JzNi","acitve":"CommTypeTabs_acitve__iTk0h","tabLabel":"CommTypeTabs_tabLabel__1A1t1","tabIcon":"CommTypeTabs_tabIcon__3UQOa"};